var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"row-fix"},[_c('b-col',{staticClass:"column",attrs:{"sm":"8"}},[_c('Introduction')],1),_c('b-col',{staticClass:"column",attrs:{"sm":"4"}},[_c('Calendar')],1)],1),_c('hr'),_c('Maps')],1)}
var staticRenderFns = []

export { render, staticRenderFns }